<template>
  <div class="m-group mb-4">
    <m-title v-if="label" :label="label"/>
    <vs-row>
      <vs-col class="m-group-body" :style="{
      '--division': division,
      '--grid-row-gap': rowGap,
      '--grid-column-gap': columnGap,
    }">
        <slot></slot>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import MTitle from '@/components/base-ui/MTitle'
export default {
  name: 'MGroup',
  components: { MTitle },
  props: {
    label: { type: String },
    columnGap: { type: String, default: () => { return '1rem' }},
    rowGap: { type: String, default: () => { return '1rem' }},
    division: { type: Number, default: () => { return 1 }},
  },
}
</script>

<style lang="scss" scoped>
.m-group-body {
  display: grid;
  grid-row-gap: var(--grid-row-gap);
  grid-column-gap: var(--grid-column-gap);
  grid-template-columns: repeat(var(--division), 1fr);
}
</style>
